export default function splitUrl(url, keyword) {
  const splitPoint = url.indexOf(keyword) + keyword.length;
  return {
    prefix: url.slice(0, splitPoint),
    imageUrl: url.slice(splitPoint, url.length),
  };
}
